import * as React from 'react';

import {OnboardingChecklist as OnboardingChecklistShell} from 'shells/onboarding-checklist/onboarding-checklist';

import {getOnboardingChecklistItems} from '../../../onboarding/onboarding-checklist/helpers';
import {OpenableModals, useOpenableModal} from '../../../openable-modals';

import {appHistory} from '../../../../history';
import {useDismissibleUserSetting} from '../../../../util/hooks/use-dismissible-user-setting';

import {useGetMarketingDashboardChecklist} from '../graphql/hooks';

const HAS_DISMISSED_CHECKLIST = 'has_dismissed_marketing_dashboard_checklist';

export function MarketingDashboardChecklist() {
    const {marketingDashboardChecklist, completedCount, totalCount, checklistIsComplete} =
        useGetMarketingDashboardChecklist();
    const {shouldShow, onDismiss} = useDismissibleUserSetting(HAS_DISMISSED_CHECKLIST);
    const {onOpen: onOpenAnalyticsModal} = useOpenableModal(
        OpenableModals.ANALYTICS_ONBOARDING_MODAL
    );

    if (
        !shouldShow ||
        !marketingDashboardChecklist ||
        !onDismiss ||
        !marketingDashboardChecklist.isAvailable
    ) {
        return null;
    }

    const checklist = {
        ...marketingDashboardChecklist,
        items: getOnboardingChecklistItems({
            items: marketingDashboardChecklist.items,
            openAnalyticsModal: onOpenAnalyticsModal,
        }),
    } as const;

    return (
        <div className='mb-16'>
            <OnboardingChecklistShell
                checklist={checklist}
                onClose={() => {
                    onDismiss();
                }}
                // @ts-expect-error
                completedCount={completedCount}
                // @ts-expect-error
                totalCount={totalCount}
                // @ts-expect-error
                checklistIsComplete={checklistIsComplete}
                history={appHistory}
                title='Explore Nutshell Marketing at your own pace'
                hasCollapsedButton={true}
            />
        </div>
    );
}
